import { useCallback, useMemo } from 'react';

import useNavigation from '@/hooks/useNavigation';
import CreateClientModal from '@/modules/clients/components/CreateClientModal';
import { adaptCreateClientInputToFormValue } from '@/modules/clients/components/CreateClientModal/utils';
import { clientRoutes } from '@/modules/clients/routes';

import { DialogProps } from '../types';

function AddClient({ onClose, client }: DialogProps) {
  const formValue = useMemo(() => adaptCreateClientInputToFormValue(client), [client]);

  const navigation = useNavigation();

  const openCreatedClient = useCallback(
    (client: { id: string }) => {
      navigation.push(clientRoutes.ClientDetails(client.id));
    },
    [navigation],
  );

  const clientId = client && 'id' in client ? client.id : undefined;

  return (
    <CreateClientModal
      clientId={clientId}
      initialFormValues={formValue}
      onClose={onClose}
      onSuccess={openCreatedClient}
    />
  );
}

export default AddClient;
